export default __webpack_public_path__ + "static/media/Rule18.ba6ab6c5.png";